var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-image__container"},[(_vm.avatar)?_c('div',{staticClass:"image",style:(_vm.userAvatar(_vm.avatar))}):_c('div',{staticClass:"image"},[_c('i',{staticClass:"icon-menu-profile"})]),_c('p',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }